import React from 'react';
import classNames from 'classnames';

import {Price} from 'components/__helpers/price/price';
import {Feature} from 'components/feature';

import s from './price.scss';

export type PropsType = {
    regular?: number;
    discount?: number;
    label?: React.ReactElement;
    placeholder?: boolean;
};

/**
 * Category Item Price Component
 * @param {PropsType} props - component properties
 * @returns {React.NamedExoticComponent} rendered component
 */
export const ItemPrice = React.memo<PropsType>(
    ({regular, discount, label = '', placeholder = false}) => {
        const hasDiscount = regular !== discount;

        return (
            <div className={classNames(s.container, {[s.placeholder]: placeholder})}>
                {!placeholder && (
                    <span
                        data-test-name="regularPrice"
                        className={classNames(s.price, {[s.previous]: hasDiscount})}
                    >
                        <Price>{regular}</Price>
                    </span>
                )}
                {hasDiscount && (
                    <span data-test-name="specialPrice" className={classNames(s.price, s.new)}>
                        <Price>{discount}</Price>
                    </span>
                )}
                {Boolean(label) && (
                    <Feature
                        flag="mAppCTPAdjustments3"
                        fallback={<span className={s.label}>{label}</span>}
                    />
                )}
            </div>
        );
    },
);
